import { useSearchParams } from "react-router-dom";
import { usePlannerContext } from "../../api/routing";
import "../../styles/routing.css";
import { filterFromSearch } from "../sites/siteFilter";
import Planner from "./Planner";
import RoutingTabs from "./RoutingTabs";

/** Routing: choose the sites, the depot and an optional meeting point, plan
 * the days on real road routing, give each day a crew and a date, save the
 * plan and accept it, which raises one draft inspection per stop. Opened from
 * the Sites screen, it starts from that screen's filter and ticked sites. */
export default function RoutingPage() {
  const [params] = useSearchParams();
  const context = usePlannerContext(params.toString() ? `?${params.toString()}` : "");
  return (
    <div className="page-bleed routing-page">
      <RoutingTabs />
      {context.isPending ? <p className="app-loading">Loading the planner…</p> : null}
      {context.isError ? <p className="notice bad">The planner could not be loaded: {context.error.message}</p> : null}
      {context.data ? <Planner context={context.data} initialFilter={filterFromSearch(params)} /> : null}
    </div>
  );
}
